const toastOptions = {
    position: 'top-right',
  };
  
  export default toastOptions;
  